import { BaseSection } from './BaseSection';

interface FormSectionSimpleProps {
  children: JSX.Element;
  titleAside?: JSX.Element;
  title: string;
}

export const FormSectionSimple: React.FC<FormSectionSimpleProps> = ({
  children,
  title,
  titleAside,
}) => {
  return (
    <BaseSection title={title} titleAside={titleAside}>
      <div className="grid grid-cols-6 gap-4">
        {children}
      </div>
    </BaseSection>
  );
};
